import aiServer from '@assets/images/solution/recommendation/mobile/aiServer.avif';
import co2 from '@assets/images/solution/recommendation/mobile/co2.avif';
import edgeRtls from '@assets/images/solution/recommendation/mobile/edgeRtls.avif';
import fisheye from '@assets/images/solution/recommendation/mobile/fisheye.avif';
import idCard from '@assets/images/solution/recommendation/mobile/idCard.avif';
import ipCamera from '@assets/images/solution/recommendation/mobile/ipCamera.avif';
import loraGateway from '@assets/images/solution/recommendation/mobile/loraGateway.avif';
import nvr from '@assets/images/solution/recommendation/mobile/nvr.avif';
import patientTag from '@assets/images/solution/recommendation/mobile/patientTag.avif';
import ptz from '@assets/images/solution/recommendation/mobile/ptz.avif';
import safeCradle from '@assets/images/solution/recommendation/mobile/safeCradle.avif';
import safeTag from '@assets/images/solution/recommendation/mobile/safeTag.avif';
import safetyBell from '@assets/images/solution/recommendation/mobile/safetyBell.avif';
import server from '@assets/images/solution/recommendation/mobile/server.avif';
import slimTag from '@assets/images/solution/recommendation/mobile/slimTag.avif';
import stickerTag from '@assets/images/solution/recommendation/mobile/stickerTag.avif';
import switchImg from '@assets/images/solution/recommendation/mobile/switch.avif';
import twintrackerUwb from '@assets/images/solution/recommendation/mobile/twintrackerUwb.avif';
import uwbTag from '@assets/images/solution/recommendation/mobile/uwbTag.avif';
import plutoconPro from '@assets/images/solution/recommendation/mobile/plutoconPro.avif';
import twintrackerBLE from '@assets/images/solution/recommendation/mobile/twintrackerBle.avif';
export default {
  ipCamera: {
    title: 'IP 摄像头',
    desc: 'IP 摄像头通过互联网协议传输视频数据，是一种数字 CCTV。它安装简便，支持远程监控和视频存储，广泛用于安全、安防和运营管理。',
    img: ipCamera,
    link: '/camera/edge',
  },
  ptzCamera: {
    title: 'PTZ 摄像头',
    desc: 'PTZ（云台/倾斜/变焦）摄像头是一种高性能 CCTV，支持远程控制云台旋转、倾斜和光学变焦，可用单台设备高效监控大范围区域。',
    img: ptz,
    link: '/camera/edge',
  },
  fisheyeCamera: {
    title: '鱼眼摄像头',
    desc: '鱼眼摄像头使用超过180°的超广角镜头，一台设备即可覆盖大范围区域。虽有畸变，但可实现无盲区全景监控。',
    img: fisheye,
    link: '/camera/edge',
  },
  co2: {
    title: 'CO₂ 检测器',
    desc: 'CO₂ 检测器实时监测空气中的 CO₂ 浓度，达到危险阈值时发出报警并提供视觉提示。支持电池或外部供电，是现场安全管理的重要设备。',
    img: co2,
    link: '/iot/co2',
  },
  server: {
    title: 'ORBRO 服务器',
    desc: 'ORBRO 服务器是核心中央平台，整合 RTLS、监控摄像头、传感器等设备数据，提供实时分析、报表、告警功能，并通过 API 无缝对接企业系统。',
    img: server,
    link: '/os/server',
  },
  aiServer: {
    title: 'ORBRO AI 服务器',
    desc: 'ORBRO AI 服务器实时分析现场视频和传感器数据，自动识别异常并立即发送告警与报告，无需经过网络，属于智能边缘 AI 分析服务器。',
    img: aiServer,
    link: '/camera/server',
  },
  nvr: {
    title: 'NVR',
    desc: 'NVR（网络视频录像机）通过网络接收摄像头传输的视频进行存储管理，可同时录制多路视频，并提供实时监控及回放检索功能，是视频存储的理想解决方案。',
    img: nvr,
    link: '/camera/server',
  },
  twintrackerUWB: {
    title: 'TwinTracker UWB',
    desc: 'TwinTracker UWB 是一款超宽带定位读写器，可接收 UWB 信号并计算 ±10 cm 精度的位置数据，支持多标签追踪，适用于复杂环境中的高稳定实时定位。',
    img: twintrackerUwb,
    link: '/rtls/uwb',
  },
  twintrackerBLE: {
    title: 'TwinTracker BLE',
    desc: 'TwinTracker BLE 是一款基于低功耗蓝牙的室内定位读写器，可按区域追踪标签位置，安装运维简便，适合大规模资产及人员管理。',
    img: twintrackerBLE,
    link: '/rtls/uwb',
  },
  uwbTag: {
    title: 'UWB 标签',
    desc: 'UWB 标签可贴附在人员或设备上，实现 ±10 cm 精度的实时定位，具备防震、防水、低功耗特性，适合长期使用。',
    img: uwbTag,
    link: '/rtls/uwb',
  },
  stickerTag: {
    title: '贴片标签',
    desc: '贴片标签是一种超小型资产追踪标签，便于贴附，支持实时定位与移动轨迹采集，轻便低功耗，适用于物流与制造环境。',
    img: stickerTag,
    link: '/rtls/uwb',
  },
  slimTag: {
    title: 'Slim 标签',
    desc: 'Slim 标签采用卡片形超薄设计，基于 BLE 技术，可轻松插入制服口袋或贴附资产表面，具有轻便低功耗特性，适合室内人员与资产定位。',
    img: slimTag,
    link: '/rtls/uwb',
  },
  edgeRtls: {
    title: 'ORBRO Edge RTLS',
    desc: 'ORBRO Edge RTLS 是一款边缘设备，可现场实时处理标签信号并计算位置，具备超低延迟，无需云端即可独立运行。',
    img: edgeRtls,
    link: '/os/rtls',
  },
  edgeAi: {
    title: 'ORBRO Edge AI',
    desc: 'ORBRO Edge AI 是一款边缘设备，可现场实时处理标签信号并计算位置，具备超低延迟，无需云服务支持，可独立运行。',
    img: edgeRtls,
    link: '/os/rtls',
  },
  switch: {
    title: 'L2 PoE 交换机',
    desc: 'L2 PoE 交换机通过以太网线同时提供电力和数据连接，高效连接 IP 摄像头、UWB 天线、BLE 读写器等设备，提高布线效率。',
    img: switchImg,
    link: '/os/switch',
  },
  plutoconPro: {
    title: 'Plutocon Pro',
    desc: 'Plutocon Pro 是一款工业级 BLE 信标，具备强信号发射能力，远距离稳定定位，支持防水防尘设计与可更换电池，适用于物流、制造和资产管理环境。',
    img: plutoconPro,
    link: '/rtls/ble',
  },
  safeTag: {
    title: 'Safe 标签',
    desc: 'Safe 标签可贴附于智能手机、平板等展示设备，实时检测脱离、分离、震动等异常并发送警报，是专用安全标签。',
    img: safeTag,
    link: '/os/rtls',
  },
  safetyBell: {
    title: '安全警铃',
    desc: '安全警铃在紧急情况下提供即时声光报警，可无线接入系统，提高全场安全响应效率。',
    img: safetyBell,
    link: '/os/rtls',
  },
  safeCradle: {
    title: 'Safe 底座',
    desc: 'Safe 底座是用于固定 Safe 标签和展示设备的专用支架，支持供电、无线通信和安全检测，具备防拆设计和精准对接角度，异常时能立即触发报警。',
    img: safeCradle,
    link: '/os/rtls',
  },
  loraGateway: {
    title: 'LoRa 网关',
    desc: 'LoRa 网关是基于 LoRaWAN 协议的远程通信网关，可从远程传感器或标签获取数据，并将其传输至边缘服务器或云端。',
    img: loraGateway,
    link: '/os/rtls',
  },
  patientTag: {
    title: '患者标签',
    desc: '患者标签是低功耗 UWB/BLE 可穿戴设备，适用于医院环境，可实时追踪患者位置，并在区域脱离或紧急事件时自动触发告警，便于快速响应。',
    img: patientTag,
    link: '/rtls/ble',
  },
  idCard: {
    title: '身份卡',
    desc: '身份卡（员工证）用于人员识别与出入控制，采用耐用塑料材质，内置 BLE 芯片，支持快速安全的非接触式认证。',
    img: idCard,
    link: '/rtls/ble',
  },
};
